export function useLocalizedSlug(data) {
    const slugify = {};

    slugify[data.language] = { slug: data.slug };

    if (data.localized) {
        for (let i = 0; i < data.localized.length; i++) {
            const localization = data.localized[i];
            slugify[localization.language] = {
                slug: localization.slug
            };
        }
    }

    return slugify;
}